import React from "react";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { changeAvatar, initClient, logIn } from "../loginSlice";
import { getCorrectFormatAvatar } from "features/userProfile/api";
import { sendClientCommand } from "helpers/functions/clientCommand";
import { useNotification } from "shared/hooks";
import { Formik } from "formik";
import * as Yup from "yup";
import { ValidTextField } from "helpers/NewValidate";
import { setToken } from "helpers/TokenHelper";
import Button from "@mui/material/Button";
import { apiLogon } from "app/axios";

const AuthContainer = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("core/modules/auth");
  const history = useHistory();
  const { showNotify } = useNotification();

  const checkClient = async () => {
    const { v4: uuidv4 } = require("uuid");
    const clientId = uuidv4();
    sendClientCommand(`init/${clientId}`);
    setTimeout(
      () =>
        apiLogon.checkInitClient(clientId).then(() => dispatch(initClient())),
      5000
    );
  };

  return (
    <Container component="main" maxWidth="xs">
      <Paper
        style={{
          marginTop: "40px",
          padding: "30px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
        elevation={3}
      >
        <Formik
          initialValues={{ email: "", password: "" }}
          validationSchema={Yup.object({
            email: Yup.string().required(t("validate.empty")),
            password: Yup.string().required(t("validate.empty")),
          })}
          onSubmit={(values) => {
            apiLogon
              .authorizeUser({
                email: values.email,
                password: values.password,
              })
              .then(async (response) => {
                const user = response.data;
                setToken(user.jwtToken);
                dispatch(logIn(user));
                checkClient();
                const imgBase64 = await getCorrectFormatAvatar(user.id);
                dispatch(changeAvatar(imgBase64));
                if (history.location.pathname.length === 1) {
                  history.push("documents");
                }
              })
              .catch((error) => showNotify(t("notValidData"), error.message));
          }}
        >
          {(props) => (
            <form onSubmit={props.handleSubmit}>
              <ValidTextField
                InputLabelProps={{ shrink: true }}
                placeholder={t("inputUsernameOrMail")}
                label={t("usernameOrMail")}
                margin="normal"
                required
                fullWidth
                name="email"
                autoComplete="login"
                value={props.values.email}
                onChange={(e: any) => props.handleChange(e)}
              />
              <ValidTextField
                InputLabelProps={{ shrink: true }}
                placeholder={t("inputPassword")}
                label={t("password")}
                margin="normal"
                required
                fullWidth
                name="password"
                type="password"
                value={props.values.password}
                onChange={(e: any) => props.handleChange(e)}
              />
              <Button
                variant="accept"
                type="submit"
                style={{ width: "100%", margin: 0, marginTop: "10px" }}
              >
                {t("sign")}
              </Button>
            </form>
          )}
        </Formik>
      </Paper>
    </Container>
  );
};

export default AuthContainer;
